import "./css/style.scss"




// 3rd party packages from NPM
import slick from 'slick-carousel';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';

// Our modules / classes
import HeroSlider from './js/modules/HeroSlider';
import DynamicDiv from './js/modules/DynamicDiv';
import Gallery from './js/modules/Gallery';
import MobileNav from "./js/modules/MobileNav";


// Instantiate a new object using our modules/classes
var heroSlider = new HeroSlider();
var dynamicDiv = new DynamicDiv();
var gallery = new Gallery();
var mobileNav= new MobileNav();